import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

// import ActivitiesApiMock from './activityApi.mock';

class ActivitiesApi {
  static getAllActivities(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.activitiesList, { params });
  }

  static getAllActivityReportingGroups(page, pageSize, filters, sorted) {
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.activityReportingGroupsList, { params });
  }

  static exportActivities(filters, sorted) {
    const params = drfQueryParams(0, 0, filters, sorted);
    return axios.get(ApiEndpoints.activityExport, { params });
  }

  static getActivity({ id }) {
    return axios.get(ApiEndpoints.activity.replace(':id:', id));
  }

  static deleteActivity({ id }) {
    return axios.delete(ApiEndpoints.activity.replace(':id:', id));
  }

  static getActivityReportingGroup({ id }) {
    return axios.get(ApiEndpoints.activityReportingGroup.replace(':id:', id));
  }

  static deleteActivityReportingGroup({ id }) {
    return axios.delete(ApiEndpoints.activityReportingGroup.replace(':id:', id));
  }

  static updateActivity(params) {
    const { id } = params;
    return axios.put(ApiEndpoints.activity.replace(':id:', id), params);
  }

  static updateActivityReportingGroup(id, rg) {
    return axios.put(ApiEndpoints.activityReportingGroup.replace(':id:', id), rg);
  }

  static createActivity(params) {
    return axios.post(ApiEndpoints.activitiesList, params);
  }

  static createActivityReportingGroup(rg) {
    return axios.post(ApiEndpoints.activityReportingGroupsList, rg);
  }

  static listActivities(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.activitiesList, { params });
  }

  static getActivityTemplates(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.activityTemplatesList, { params });
  }

  static addActivityToCompetencies(props) {
    const { id, params } = props;
    return axios.post(ApiEndpoints.activityBulkAddCompetencies.replace(':id:', id), { competencies: params });
  }

  static removeActivityFromCompetencies(props) {
    const { id, params } = props;
    return axios.post(ApiEndpoints.activityBulkRemoveCompetencies.replace(':id:', id), { competencies: params });
  }

  static getAllActivityTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.activityTypeList, { params });
  }

  static createActivityType(params) {
    return axios.post(ApiEndpoints.activityTypeList, params);
  }

  static updateActivityType(params) {
    const { id } = params;
    return axios.put(ApiEndpoints.activityType.replace(':id:', id), params);
  }

  static getActivityType({ id }) {
    return axios.get(ApiEndpoints.activityType.replace(':id:', id));
  }

  static deleteActivityType({ id }) {
    return axios.delete(ApiEndpoints.activityType.replace(':id:', id));
  }
}

export default ActivitiesApi;
